import { setContext } from '@apollo/client/link/context';
import { getOrganization } from '../auth';
import { tokenStorage } from './types';

export const authLink = setContext((_, { headers }) => {
  const token = tokenStorage.getAccessToken();

  let organizationId: string | undefined;
  try {
    organizationId = getOrganization()?.id;
  } catch {
    // Ignore
  }

  return {
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...(organizationId ? { 'x-organization-id': organizationId } : {}),
    },
  };
});
